import axios from "axios";

export default axios.create({
  baseURL:
    "https://xz-gaudi-api-1-a8addwa7bmh0g2hc.eastus-01.azurewebsites.net/",
  //baseURL: "http://localhost:3000/",
});
